
export default {
  name: "cal-subs-cart-dialog-steps",
  props: {
    steps: {
      type: Array,
    },
    size: {
      type: Number,
    },
    showCartDialog: {
      type: Boolean,
    },
    onSubmit: {
      type: Function,
    },
    showFooterActions: {
      type: Boolean,
    },
    sliderSize: {
      type: String,
    },
    showSteps: {
      type: Boolean,
      default: true,
    },
    showStepHeader: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showSlideOver: this.showCartDialog,
      currentTab: 0,
      disableTabChange: false,
    };
  },
  watch: {
    showCartDialog() {
      this.showSlideOver = this.showCartDialog;
      this.showSlideOver
        ? this.$nuxt.$emit("hideChat")
        : this.$nuxt.$emit("showChat");
      window.dataLayer?.push({
        event: "screen_view",
        screen_name: this.steps[this.currentTab].name,
      });
    },
  },
  created() {
    this.$nuxt.$on("disableContinueSubs", (status) => {
      this.disableTabChange = status;
    });
  },
  methods: {
    handleClickAndMove() {
      if (!this.disableTabChange) {
        if (this.currentTab < this.size) {
          this.moveToNext();
        } else if (this.currentTab === this.size) {
          this.submit();
        }
      } else if (
        this.disableTabChange &&
        this.steps[this.currentTab].name === "recipient_details"
      ) {
        this.$nuxt.$emit("runInputFieldsValidation");
      }
    },
    moveToNext() {
      if (this.currentTab < this.size) {
        this.currentTab = this.currentTab + 1;
        window.dataLayer?.push({
          event: "screen_view",
          screen_name: this.steps[this.currentTab].name,
        });
      }
    },
    backToPrevious() {
      if (this.currentTab != 0) {
        this.currentTab = this.currentTab - 1;
        // $nuxt.$emit("toBack");
        window.dataLayer?.push({
          event: "screen_view",
          screen_name: this.steps[this.currentTab].name,
        });
      }
    },
    closeSlideOver() {
      this.currentTab = 0;
      this.showSlideOver = false;
      this.$emit("closeSlideOver");
    },
    submit() {
      if (this.onSubmit) {
        this.onSubmit();
        return;
      }

      // TODO loading from session to vue-store logic be move to mixin
      const existingSessionCartItems = sessionStorage.cartItems
        ? JSON.parse(sessionStorage.cartItems)
        : null;
      if (existingSessionCartItems) {
        this.$store.dispatch(
          "lineItems/FILL_CART_ITEMS",
          existingSessionCartItems
        );
      }
      this.$store.dispatch("lineItems/ADD_CART_ITEM", {
        ...this.$store.state.cartItem,
      });
      sessionStorage.cartItems = JSON.stringify(
        this.$store.state.lineItems.cartItems
      );

      this.$nuxt.$emit("cartItemsUpdated");

      this.$store.dispatch("cartItem/CART_ITEM_FLUSH");

      this.showSlideOver = false;
      this.$emit("closeSlideOver");
      this.currentTab = 0;

      this.$router.push(`/${this.$i18n.locale}/cart`);
    },
  },
  beforeUnmount() {
    this.$nuxt.$off("tabChange");
    this.$nuxt.$off("toBack");
    this.$nuxt.$off("disableContinueSubs");
  },
};
